<script>
	export default {
		name: 'TrainingExecuter',
		data() {
			return {
				trainings_: {}
			}
		},
		methods: {
			getFirstModuleCode(courseCode) {
				const self_ = this;

				const trainings_ = self_.getTrainingsState(courseCode)

				if(self_.isEmpty(trainings_)) { return null }

				return self_.getObjectFirstKey(trainings_.modules)
			},
			getLastModuleCode(courseCode) {
				const self_ = this;

				const trainings_ = self_.getTrainingsState(courseCode)

				if(self_.isEmpty(trainings_)) { return null }

				return self_.getObjectLastKey(trainings_.modules)
			},
			getNextModuleCode(courseCode, moduleCode) {
				const self_ = this;

				const trainings_ = self_.getTrainingsState(courseCode)

				if(self_.isEmpty(trainings_)) { return null }

				return self_.getObjectNextKey(trainings_.modules, moduleCode)
			},
			getPreviousModuleCode(courseCode, moduleCode) {
				const self_ = this;

				const trainings_ = self_.getTrainingsState(courseCode)

				if(self_.isEmpty(trainings_)) { return null }

				return self_.getObjectPreviousKey(trainings_.modules, moduleCode)
			},
			getFirstSectionCode(courseCode, moduleCode) {
				const self_ = this;

				const trainings_ = self_.getTrainingsState(courseCode)

				if(self_.isEmpty(trainings_)) { return null }

				return self_.getObjectFirstKey(trainings_.modules[moduleCode].sections)
			},
			getLastSectionCode(courseCode, moduleCode) {
				const self_ = this;

				const trainings_ = self_.getTrainingsState(courseCode)

				if(self_.isEmpty(trainings_)) { return null }

				return self_.getObjectLastKey(trainings_.modules[moduleCode].sections)
			},
			getNextSectionCode(courseCode, moduleCode, sectionCode) {
				const self_ = this;

				const trainings_ = self_.getTrainingsState(courseCode)

				if(self_.isEmpty(trainings_)) { return null }

				return self_.getObjectNextKey(trainings_.modules[moduleCode].sections, sectionCode)
			},
			getPreviousSectionCode(courseCode, moduleCode, sectionCode) {
				const self_ = this;

				const trainings_ = self_.getTrainingsState(courseCode)

				if(self_.isEmpty(trainings_)) { return null }

				return self_.getObjectPreviousKey(trainings_.modules[moduleCode].sections, sectionCode)
			},
			openTrainingCourse(uid, courseCode) {
				const self_ = this;

				const trainings_ = self_.getTrainingsState(courseCode)

				if(self_.isEmpty(trainings_)) { return }

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.updateUserTrainingStatus(uid, courseCode, null, null, 'opened')
					}).then(() => {
						const modules_ = trainings_.modules;
						// open modules
						let promiseArray_ = []
						Object.keys(modules_).forEach(moduleCode => {
							promiseArray_.push(self_.openTrainingModule(uid, courseCode, moduleCode))
						})
						return Promise.all(promiseArray_)
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			openTrainingModule(uid, courseCode, moduleCode) {
				const self_ = this;

				const trainings_ = self_.getTrainingsState(courseCode)

				if(self_.isEmpty(trainings_)) { return }

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.updateUserTrainingStatus(uid, courseCode, moduleCode, null, 'opened')
					}).then(() => {
						const sections_ = trainings_.modules[moduleCode].sections;
						// open sections
						let promiseArray_ = []
						Object.keys(sections_).forEach(sectionsCode => {
							promiseArray_.push(self_.openTrainingSection(uid, courseCode, moduleCode, sectionsCode))
						})
						return Promise.all(promiseArray_)
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			openTrainingSection(uid, courseCode, moduleCode, sectionCode) {
				const self_ = this;

				const trainings_ = self_.getTrainingsState(courseCode)

				if(self_.isEmpty(trainings_)) { return }

				return self_.updateUserTrainingStatus(uid, courseCode, moduleCode, sectionCode, 'opened')
			},
			closeTrainingCourse(uid, courseCode) {
				const self_ = this;

				const trainings_ = self_.getTrainingsState(courseCode)

				if(self_.isEmpty(trainings_)) { return }

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUserTrainingData({ uid: uid, courseCode: courseCode, moduleCode: null, sectionCode: null })
					}).then(result => {
						const status_ = result[0].status;
						// not opened yet
						if(self_.isEmpty(result)) { return Promise.resolve() }
						// finished or closed
						else if (status == 'finished' || status == 'closed') { return Promise.resolve() }
						// opened or started
						else {
							return self_.updateUserTrainingStatus(uid, courseCode, null, null, 'closed')
						}
					}).then(() => {
						const modules_ = trainings_.modules;
						// close modules
						let promiseArray_ = []
						Object.keys(modules_).forEach(moduleCode => {
							promiseArray_.push(self_.closeTrainingModule(uid, courseCode, moduleCode))
						})
						return Promise.all(promiseArray_)
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			closeTrainingModule(uid, courseCode, moduleCode) {
				const self_ = this;

				const trainings_ = self_.getTrainingsState(courseCode)

				if(self_.isEmpty(trainings_)) { return }

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUserTrainingData({ uid: uid, courseCode: courseCode, moduleCode: moduleCode, sectionCode: null })
					}).then(result => {
						const status_ = result[0].status;

						// not opened yet
						if(self_.isEmpty(result)) { return Promise.resolve() }
						// finished or closed
						else if (status == 'finished' || status == 'closed') { return Promise.resolve() }
						// opened or started
						else {
							return self_.updateUserTrainingStatus(uid, courseCode, moduleCode, null, 'closed')
						}
					}).then(() => {
						const sections_ = trainings_.modules[moduleCode].sections;
						// close sections
						let promiseArray_ = []
						Object.keys(sections_).forEach(sectionsCode => {
							promiseArray_.push(self_.closeTrainingSection(uid, courseCode, moduleCode, sectionsCode))
						})
						return Promise.all(promiseArray_)
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			closeTrainingSection(uid, courseCode, moduleCode, sectionCode) {
				const self_ = this;

				const trainings_ = self_.getTrainingsState(courseCode)

				if(self_.isEmpty(trainings_)) { return }

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUserTrainingData({ uid: uid, courseCode: courseCode, moduleCode: moduleCode, sectionCode: sectionCode })
					}).then(result => {
						const status_ = result[0].status;

						// not opened yet
						if(self_.isEmpty(result)) { return Promise.resolve() }
						// finished or closed
						else if (status == 'finished' || status == 'closed') { return Promise.resolve() }
						// opened or started
						else {
							return self_.updateUserTrainingStatus(uid, courseCode, moduleCode, sectionCode, 'closed')
						}
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			getUserTrainingStatus(uid, courseCode, moduleCode, sectionCode) {
				const self_ = this;

				const userTrainingData_ = self_.getUserState('trainingData')

				let result_ = null;

				userTrainingData_.forEach(data => {
					if(data.course_code == courseCode && data.module_code == moduleCode && data.section_code == sectionCode) {
						result_ = data.status;
					}
				})

				return result_
			},
			updateUserTrainingStatus(uid, courseCode, moduleCode, sectionCode, status) {
				const self_ = this;

				const trainings_ = self_.getTrainingsState(courseCode)

				if(self_.isEmpty(trainings_)) { return }

				const courseTitle_ = self_.getLangsVal(trainings_.title, 'default')
				let moduleTitle_ = null;
				if(!self_.isFalse(moduleCode)) { moduleTitle_ = self_.getLangsVal(trainings_.modules[moduleCode].title, 'default') }
				let sectionTitle_ = null;
				if(!self_.isFalse(sectionCode)) { sectionTitle_ = self_.getLangsVal(trainings_.modules[moduleCode].sections[sectionCode].title, 'default') }

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUserTrainingData({ uid: uid, courseCode: courseCode, moduleCode: moduleCode, sectionCode: sectionCode })
					}).then(result => {
						if(self_.isEmpty(result)) {
							return self_.ipCliStoreAppUserTrainingData(uid, courseCode, courseTitle_, moduleCode, moduleTitle_, sectionCode, sectionTitle_, status)
						} else {
							return self_.ipCliUpdateAppUserTrainingData(uid, courseCode, moduleCode, sectionCode, { status: status })
						}
					}).then(() => {
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			storeTrainingTests(courseCode, moduleCode, sectionCode, startedDatetime, finishedDatetime, time, score) {
				const self_ = this;

				const datetime_ = self_.formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss')
				const uid_ = self_.getCurrentUser('uid')

				const pageName_ = self_.getInputState('pageName')
				const pageType_ = self_.getInputState('pageType')
				const data_ = self_.getInputState('data')

				const trainings_ = self_.getTrainingsState(courseCode)

				if(self_.isEmpty(trainings_)) { return }

				const courseTitle_ = self_.getLangsVal(trainings_.title, 'default')
				let moduleTitle_ = null;
				if(!self_.isFalse(moduleCode)) { moduleTitle_ = self_.getLangsVal(trainings_.modules[moduleCode].title, 'default') }
				let sectionTitle_ = null;
				if(!self_.isFalse(sectionCode)) { sectionTitle_ = self_.getLangsVal(trainings_.modules[moduleCode].sections[sectionCode].title, 'default') }

				return self_.ipCliStoreTrainingTests(datetime_, uid_, pageName_, pageType_, courseCode, courseTitle_, moduleCode, moduleTitle_, sectionCode, sectionTitle_, startedDatetime, finishedDatetime, time, score, data_)
			},
			initializeTrainings(courseCode) {
				const self_ = this;

				let initialized_ = self_.getTrainingsState('isInitialized')

				if(courseCode && initialized_[courseCode]) { return }

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						// get course
						return self_.$_trnExec_getTrainingCourse()
					}).then(() => {
						// get modules
						let promiseArray_ = []
						Object.keys(self_.trainings_).forEach(key => {
							if(key == courseCode) {
								promiseArray_.push(self_.$_trnExec_getTrainingModules(key))
							}
						})
						return Promise.all(promiseArray_)
					}).then(() => {
						// get sections
						let promiseArray_ = []
						Object.keys(self_.trainings_).forEach(key => {
							if(key == courseCode) {
								Object.keys(self_.trainings_[key].modules).forEach(moduleCode => {
									promiseArray_.push(self_.$_trnExec_getTrainingSections(key, moduleCode))
								})
							}
						})
						return Promise.all(promiseArray_)
					}).then(() => {
						if(self_.isFalse(courseCode)) {
							Object.keys(self_.trainings_).forEach(courseCode => {
								self_.setTrainingsState(courseCode, self_.trainings_[courseCode])
							})
						} else {
							self_.setTrainingsState(courseCode, self_.trainings_[courseCode])
							// initialized
							if(!self_.isFalse(courseCode)) {
								initialized_[courseCode] = true
								self_.setTrainingsState('isInitialized', initialized_)
							}
						}

						resolve()
					}).catch(error => {
						reject(error)
					})
				})				
			},
			$_trnExec_getTrainingCourse() {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getFirestoreCollection('trainings', {}, 0)
					}).then(result => {
						Object.keys(result).forEach(courseCode => {
							self_.trainings_[courseCode] = result[courseCode]
						})
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			$_trnExec_getTrainingModules(courseCode) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getFirestoreSubCollection('trainings', courseCode, 'modules')
					}).then(result => {
						self_.trainings_[courseCode].modules = result;
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			},
			$_trnExec_getTrainingSections(courseCode, moduleCode) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getFirestoreSubSubCollection('trainings', courseCode, 'modules', moduleCode, 'sections')
					}).then(result => {
						self_.trainings_[courseCode].modules[moduleCode].sections = result;
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			}
		}
	}
</script>